import { useContext, useCallback } from 'react';
import FirebaseContext from '../components/Firebase/context';
import { AuthUserContext } from '../components/Session';

export function useActivityLog() {
  const firebase = useContext(FirebaseContext);
  const authUser = useContext(AuthUserContext);

  const logActivity = useCallback((organization, action, details = {}) => {
    if (!firebase || !authUser || !organization) return Promise.resolve();
    return firebase.maybeLogOrgActivity(organization, {
      action,
      actorUid: authUser.uid,
      actorEmail: authUser.email || authUser.providerData?.[0]?.email || null,
      details,
    }).catch(() => {});
  }, [firebase, authUser]);

  return logActivity;
}
